
import { DragHelper, DropTableTypes } from '@genexus/designer-common';
import { Component, Element, Event, Prop, h, Host, Listen, EventEmitter } from '@stencil/core';

namespace DataSetConsts {
  export const PLACE_HOLDER = 'placeHolder';
  export const ROW_IDX = 'rowIndex';
  export const CELL_IDX = 'cellIndex';
  export const CELL_COLUMN = 'cellColumn';
  export const DATA_ACTIVE = 'data-active';
  export const CELL_VIRTUAL = 'cellVirtual';
}

@Component({
  tag: 'gx-drop-table-area',
  styleUrl: 'drop-table-area.scss',
  shadow: false,
})
export class DropTableArea {

  private _activeMarker: HTMLElement;

  @Element() element: HTMLElement;

  @Prop() rows: DropTableTypes.TableRow[];

  @Prop() dropCorners: 'horizontal' | 'vertical' | 'both';

  @Prop() isValidDropFn: (evt: MouseEvent, target: DropTableTypes.DropTargetInfo) => boolean;

  @Listen('dragenter')
  onDragEnter(evt: DragEvent) {
    // let data = DragHelper.getDragData(window);
    // console.log('Drag enter', evt, data);
  }

  @Listen('dragover', { passive: false })
  onDragOver(evt: DragEvent) {

    evt.preventDefault();
    evt.stopPropagation();

    let target = this._getDropTarget(evt);
    if (this._activeMarker && this._activeMarker.parentElement !== target) {
      this._activeMarker.removeAttribute(DataSetConsts.DATA_ACTIVE);
    }

    this._activeMarker = undefined;

    if (target && this._isValidDrop(evt, this._getDropTargetInfo(target, DragHelper.getDragData(window)))) {
      this._activeMarker = target.firstChild as HTMLElement;
      this._activeMarker.setAttribute(DataSetConsts.DATA_ACTIVE, 'true');
      // evt.preventDefault();
      // evt.stopPropagation();
    }
  }

  @Listen('dragleave')
  onDragLeave(evt: DragEvent) {
    if (this._activeMarker) {
      this._activeMarker.removeAttribute(DataSetConsts.DATA_ACTIVE);
    }
  }

  @Listen('drop', { passive: false })
  onDrop(evt: DragEvent) {
    if (this._activeMarker) {
      this._activeMarker.removeAttribute(DataSetConsts.DATA_ACTIVE);
    }

    let target = this._getDropTarget(evt);
    let data = DragHelper.getDragData(window);
    let dropInfo = this._getDropTargetInfo(target, data);

    if (target && this._isValidDrop(evt, this._getDropTargetInfo(target, data))) {
      evt.preventDefault();
      evt.stopPropagation();
      this.dropOnPlaceHolder.emit(dropInfo);
    }
  }

  @Event() dropOnPlaceHolder: EventEmitter<DropTableTypes.DropTargetInfo>;

  render() {
    return (
      <Host>
        {
          this.rows?.map((r, i) => this._renderRow(r, i))
        }
      </Host>
    );
  }

  private _isValidDrop(evt: DragEvent, target: DropTableTypes.DropTargetInfo) {
    return !this.isValidDropFn || this.isValidDropFn(evt, target);
  }

  private _getDropTarget(evt: DragEvent): HTMLElement {
    let target: HTMLElement = evt.target as HTMLElement;

    if (target?.dataset && target.dataset[DataSetConsts.PLACE_HOLDER])
      return target;
  }

  private _getDropTargetInfo(target: HTMLElement, data: DragHelper.DragData): DropTableTypes.DropTargetInfo {
    let cell = target.parentElement.parentElement;
    return {
      rowIndex: parseInt(cell.dataset[DataSetConsts.ROW_IDX]),
      cellIndex: parseInt(cell.dataset[DataSetConsts.CELL_IDX]),
      column: parseInt(cell.dataset[DataSetConsts.CELL_COLUMN]),
      isVirtual: parseInt(cell.dataset[DataSetConsts.CELL_VIRTUAL]) == 1,
      position: target.dataset[DataSetConsts.PLACE_HOLDER] as DropTableTypes.PlaceHolderPosition,
      data
    }
  }

  private _renderRow(row: DropTableTypes.TableRow, index: number) {
    return row.cells.map((c, cellIdx) => this._renderCell(c, index, c.cellIdx != null ? c.cellIdx : cellIdx, c.column != null ? c.column : cellIdx, c.isVirtual));
  }

  private _renderCell(cell: DropTableTypes.TableCell, rowIndex: number, cellIndex: number, column: number, isVirtual: boolean) {
    return (
      <div class="cell" data-row-index={rowIndex} data-cell-index={cellIndex} data-cell-column={column} data-cell-virtual={isVirtual ? 1 : 0} style={{ left: `${cell.bounds.x}px`, top: `${cell.bounds.y}px`, width: `${cell.bounds.width}px`, height: `${cell.bounds.height}px` }}>
        <div class="cell-content">

          {(this.dropCorners === 'horizontal' || this.dropCorners == 'both') && this._renderPlaceHolder(cell.bounds, 'top')}

          {(this.dropCorners === 'horizontal' || this.dropCorners == 'both') && this._renderPlaceHolder(cell.bounds, 'bottom')}

          {(this.dropCorners === 'vertical' || this.dropCorners == 'both') && this._renderPlaceHolder(cell.bounds, 'left')}

          {(this.dropCorners === 'vertical' || this.dropCorners == 'both') && this._renderPlaceHolder(cell.bounds, 'right')}

          {cell.isEmpty && this._renderPlaceHolder(cell.bounds, 'inside')}

        </div>
      </div>
    )
  }

  private _renderPlaceHolder(bounds: DropTableTypes.Rect, position: DropTableTypes.PlaceHolderPosition) {
    return (
      <div data-place-holder={position}>
        <div data-place-holder-marker />
      </div>
    );
  }
}